import { render } from "./Mentoring&Commitment.vue?vue&type=template&id=3965d6f1"
import script from "./Mentoring&Commitment.vue?vue&type=script&lang=js"
export * from "./Mentoring&Commitment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__